export default "__VITE_ASSET__Dwh1cPOm__"